import React, { useState, useMemo, useEffect, useRef, ReactNode } from 'react';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { modifyModalRecoil } from '@/atom/ModalAtom';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import LS from '@/styles/layoutStyled';
import CS from '@/styles/componentStyled';
import BS from '@/styles/btnStyled';
import IS from '@/styles/inputStyled';
import ModalType2 from '@/modal/ModalType2';

interface ModalProps {
  onConfirm: () => void;
}

const ModifyModal = ({ onConfirm }: ModalProps) => {
  const setModalState = useSetRecoilState(modifyModalRecoil);
  return (
    <>
      <ModalType2>
        <span className="img-box">
          <img src="./img/modal_ico_question_mark.png" alt="" />
        </span>
        <p>해당 항목을 수정하시겠습니까?</p>
        <div className="btn-box">
          <BS.Btn4Type3 type="button" onClick={() => setModalState(false)}>
            취소
          </BS.Btn4Type3>
          <BS.Btn4Type4
            type="button"
            onClick={() => {
              setModalState(false);
              onConfirm();
            }}
          >
            확인
          </BS.Btn4Type4>
        </div>
      </ModalType2>
    </>
  );
};

export default ModifyModal;
